/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  QueryPayload,
  QueryPayload$Outbound,
  QueryPayload$outboundSchema,
} from "../components/querypayload.js";

export type QuerySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type QueryRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  queryPayload: QueryPayload;
};

/** @internal */
export type QuerySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const QuerySecurity$outboundSchema: z.ZodMiniType<
  QuerySecurity$Outbound,
  QuerySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function querySecurityToJSON(querySecurity: QuerySecurity): string {
  return JSON.stringify(QuerySecurity$outboundSchema.parse(querySecurity));
}

/** @internal */
export type QueryRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  QueryPayload: QueryPayload$Outbound;
};

/** @internal */
export const QueryRequest$outboundSchema: z.ZodMiniType<
  QueryRequest$Outbound,
  QueryRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    queryPayload: QueryPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      queryPayload: "QueryPayload",
    });
  }),
);

export function queryRequestToJSON(queryRequest: QueryRequest): string {
  return JSON.stringify(QueryRequest$outboundSchema.parse(queryRequest));
}
